"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateFns = void 0;
var date_fns_1 = require("date-fns");
var locale_1 = require("date-fns/locale");
var useCurrentLang_1 = require("./useCurrentLang");
var dateFnsLocales = {
    ru: locale_1.ru,
    en: locale_1.enGB,
    es: locale_1.es
};
var useDateFns = function () {
    var lang = useCurrentLang_1.useCurrentLang();
    var formatWithLocale = function (date, formatString, options) {
        return date_fns_1.format(date, formatString, __assign(__assign({}, options), { locale: dateFnsLocales[lang] }));
    };
    var formatDistanceWithLocale = function (date, baseDate, options) {
        return date_fns_1.formatDistance(date, baseDate, __assign(__assign({}, options), { locale: dateFnsLocales[lang] }));
    };
    return { formatWithLocale: formatWithLocale, formatDistanceWithLocale: formatDistanceWithLocale };
};
exports.useDateFns = useDateFns;
